import { Analytics } from '@vercel/analytics/react'
import { SessionProvider } from 'next-auth/react'

import '../styles/globals.css'

function MyApp({ Component, pageProps: { session, ...pageProps } }) {
  return (
    <SessionProvider session={session}>
      <Component {...pageProps} />
      <Analytics />
    </SessionProvider>
  )
}

export default MyApp
